import React, { useEffect } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Checkboxes from '../../../../pages/Account/components/RxFormCustomization/FormBuilder/controls/Checkboxes';
import {
  PropsPropType,
  RulesPropType
} from '../../../../pages/Account/components/RxFormCustomization/FormBuilder/propTypes';
import { ARCHES, IDB_ATTRIBUTES } from '../constants';

export const TURBO_OCCLUSAL_STOP_JIGS_OPTION_NAME = 'Turbo / occlusal stop jigs';

const isTurboOcclusalStopJigsOption = option =>
  String(get(option, 'name', ''))
    .trim()
    .toLowerCase() === TURBO_OCCLUSAL_STOP_JIGS_OPTION_NAME.toLowerCase();

const getSelectedIds = value =>
  value
    ? String(value)
        .split(',')
        .filter(Boolean)
    : [];

const ExtraTrayOptionsField = ({ field, form, props: fieldProps, ...controlProps }) => {
  const archType = Number(get(form.values, IDB_ATTRIBUTES.ARCH_TYPE));
  const showTurboOption = archType === ARCHES.BOTH;
  const options = get(fieldProps, 'options', []);
  const turboOption = options.find(isTurboOcclusalStopJigsOption);
  const turboOptionId = turboOption ? String(turboOption.id) : null;
  const visibleOptions = showTurboOption
    ? options
    : options.filter(option => !isTurboOcclusalStopJigsOption(option));

  useEffect(() => {
    if (showTurboOption || !turboOptionId) {
      return;
    }

    const selectedIds = getSelectedIds(field.value);
    if (!selectedIds.includes(turboOptionId)) {
      return;
    }

    form.setFieldValue(field.name, selectedIds.filter(id => id !== turboOptionId).join(','));
  }, [showTurboOption, turboOptionId, field.value, field.name, form]);

  return (
    <Checkboxes
      {...controlProps}
      field={field}
      form={form}
      props={{ ...fieldProps, options: visibleOptions }}
    />
  );
};

ExtraTrayOptionsField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
  }).isRequired,
  form: PropTypes.shape({
    values: PropTypes.shape({}),
    setFieldValue: PropTypes.func.isRequired
  }).isRequired,
  props: PropsPropType,
  rules: RulesPropType,
  system_type: PropTypes.string
};

ExtraTrayOptionsField.defaultProps = {
  props: null,
  rules: null,
  system_type: null
};

export default ExtraTrayOptionsField;
